import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto py-24 px-6 text-center" data-testid="payment-cancel-page">
      <h1 className="font-serif text-4xl text-[#F7ECEB]">Payment cancelled.</h1>
      <p className="text-[#A89896] mt-4">No charge was made. You can return anytime.</p>
      <Link to="/membership" className="btn-primary inline-block mt-8">Back to membership</Link>
    </div>
  );
}
